module.exports = __webpack_public_path__ + "static/img/android5.beb968d7.jpg";